import type { Directive } from 'vue';
import { sanitizeHtml } from '@/utils/helpers/sanitize';

export const safeHtml: Directive = {
  mounted(el, binding) {
    el.innerHTML = sanitizeHtml(binding.value);
  },
  updated(el, binding) {
    el.innerHTML = sanitizeHtml(binding.value);
  },
};
